import '../LandingPage/LandingPage.scss';
import { Grid } from '@mui/material';
import dataPipelineLogo from '../../assets/apac-icon-dp.svg';

import CustomDashboardIcon from '../../assets/pbna-icon-dp.svg';
import { lazy } from 'react';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import landingBackArrow from '../../assets/landingBackArrow.svg';
import { useTheme } from "@mui/material/styles";
import { DataReconWhiteIcon } from 'components/CommonIcons/Icons';

// Lazy load components
const Footer = lazy(() => import('../LandingPage/ModuleLandingFooter'));
const capabilitiesNew: any = localStorage.getItem('capabilities');


export default function DataopsExeLanding() {
    const theme = useTheme();
    console.log(capabilitiesNew, 'capabilitiesNew==')
    const [controller] = usePepwiseAuthController();
    const { capabilities, isAuthenticated } = controller;
    
    // Use localStorage first, fallback to AuthContext
    const finalCapabilities = (isAuthenticated && !capabilitiesNew) ? capabilities : capabilitiesNew;
    let authCapabilities: string[] = [];
    if (finalCapabilities) {
        if (Array.isArray(finalCapabilities)) authCapabilities = finalCapabilities;
        else authCapabilities = finalCapabilities.split(',');
    }
    const capabilitiesArray = authCapabilities ? authCapabilities : [];

    //navigate to data-pipeline observability
    const handleDataPipelineExeOpsClick = (event: any, type: string, url: string) => {
        event.preventDefault(); // Prevent the default context menu from showing up
        if (type === 'blank') {
            // Open the URL in a new tab if type is 'blank'
            window.open(url, '_blank');
        } else {
            // Navigate to the provided URL in the current tab
            window.location.href = url;
        }
    };

    const handleBackClick = () => {
        window.location.href = '/dashboard/dataOpsLanding';
    };


    return (
        <div className="outerLandingPageContainer" style={{ backgroundColor: `${theme.palette.backgroundLight.primary}` }}>
            {/* <Header memberData={memberData} /> */}
            <div style={{ maxWidth: '86%', margin: '0 auto' }}>
                <div className="landingMessage-container">
                    <button className="landing-button-arrow" onClick={handleBackClick}>
                        <img src={landingBackArrow} alt="CCLogo" className="" />
                    </button>
                    <p className="landingMessage" style={{ color: `${theme.palette.textLight.secondary}` }}>{`End to End Observability Dashboard`}</p>
                </div>


                <div className="welcome_text">
                    <p style={{ color: `${theme.palette.textLight.secondary}` }}>Click on the module below to monitor!</p>
                </div>
                <Grid container spacing={1} style={{ marginTop: '0px' }}>

                    {capabilitiesArray.includes('Data Ops') ? (
                        <>
                        <Grid
                            item
                            xs={4}

                            onClick={(e) => handleDataPipelineExeOpsClick(e, 'no-blank', '/data-pipeline/executiveOps/sector')}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                handleDataPipelineExeOpsClick(e, 'blank', '/data-pipeline/executiveOps/sector');
                            }}
                        >
                            <div className="observalbility_screens" style={{ textAlign: 'center' }}>
                                <div className="title">
                                    <img src={dataPipelineLogo} alt="sectorLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
                                </div>
                                <div>
                                    <h3 className="obsTitle" style={{ margin: '10px 0' }}>
                                        Sector Dashboards
                                    </h3>
                                </div>
                                <p
                                    className="message1"
                                    title="Monitor jobs or pipelines for a specific project"
                                    style={{ margin: '0', textAlign: 'center' }}
                                >
                                    Monitor jobs or pipelines for a specific project
                                </p>
                            </div>
                        </Grid>
                        
                        <Grid
                            item
                            xs={4}

                            onClick={(e) => handleDataPipelineExeOpsClick(e, 'no-blank', '/data-pipeline/executiveOps/program')}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                handleDataPipelineExeOpsClick(e, 'blank', '/data-pipeline/executiveOps/program');
                            }}
                        >
                            <div className="observalbility_screens" style={{ textAlign: 'center' }}>
                                <div className="title">
                                    <img src={CustomDashboardIcon} alt="platformLogo" className="obs_logo" style={{ display: 'block', margin: '0 auto' }} />
                                </div>
                                <div>
                                    <h3 className="obsTitle" style={{ margin: '10px 0' }}>
                                        Program Dashboards
                                    </h3>
                                </div>
                                <p
                                    className="message1"
                                    title="Monitor jobs or pipelines for a specific project"
                                    style={{ margin: '0', textAlign: 'center' }}
                                >
                                    Monitor jobs or pipelines for a specific project
                                </p>
                            </div>
                        </Grid>
                        
                        <Grid
                            item
                            xs={4}

                            onClick={(e) => handleDataPipelineExeOpsClick(e, 'no-blank', '/data-pipeline/executiveOps/pepsellPepIrisRecon')}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                handleDataPipelineExeOpsClick(e, 'blank', '/data-pipeline/executiveOps/pepsellPepIrisRecon');
                            }}
                        >
                            <div className="observalbility_screens" style={{ textAlign: 'center' }}>
                                <div className="title">
                                    <div className="obs_logo" style={{ display: 'block', margin: '0 auto', color: '#fff' }}>
                                        <DataReconWhiteIcon color="#fff" />
                                    </div>
                                </div>
                                <div>
                                    <h3 className="obsTitle" style={{ margin: '10px 0' }}>
                                        Data Recon Dashboards
                                    </h3>
                                </div>
                                <p
                                    className="message1"
                                    title="Monitor the metrics and KPIs for a specific program"
                                    style={{ margin: '0', textAlign: 'center' }}
                                >
                                    Monitor the metrics and KPIs for a specific program
                                </p>
                            </div>
                        </Grid>
                        </>
                    ) : (
                        ''
                    )}
                </Grid>
            </div>
            <Footer />
        </div>
    );
}
